import React from 'react';

/**
 * Parses a notification message string, extracts any URLs / <a> links,
 * and replaces them with safe "Відкрити" anchor elements styled as buttons.
 * No raw HTML is ever injected into the DOM.
 *
 * @param {string} message - Raw message text (may contain <a> tags or bare URLs)
 * @param {function} onNavigate - history.push for internal SPA navigation
 * @returns {React.ReactNode}
 */
const parseNotificationMessage = (message, onNavigate) => {
  const text = message || 'Немає опису сповіщення';
  const parts = [];
  let key = 0;
  let lastIndex = 0;

  // Matches <a href="…">…</a> tags OR bare https?:// URLs
  const linkRegex = /<a\s[^>]*?href=(["'])([^"']+)\1[^>]*?>[\s\S]*?<\/a>|https?:\/\/[^\s<>"']+/gi;
  let match;

  while ((match = linkRegex.exec(text)) !== null) {
    const before = text.slice(lastIndex, match.index).replace(/<[^>]+>/g, '');
    if (before) parts.push(<span key={key++}>{before}</span>);

    const href = match[0].startsWith('<') ? match[2] : match[0];

    const handleOpenLink = (e) => {
      e.stopPropagation();
      const isInternal =
        href.startsWith('/') ||
        (typeof window !== 'undefined' && href.startsWith(window.location.origin));
      if (isInternal && onNavigate) {
        const path = href.startsWith('/')
          ? href
          : href.replace(window.location.origin, '');
        onNavigate(path);
      } else {
        window.location.href = href;
      }
    };

    parts.push(
      <a
        key={key++}
        className="mobile-notification-read-btn"
        role="button"
        tabIndex={0}
        onClick={handleOpenLink}
        onKeyDown={(e) => e.key === 'Enter' && handleOpenLink(e)}
      >
        <i className="fas fa-external-link-alt" /> Відкрити
      </a>,
    );

    lastIndex = match.index + match[0].length;
  }

  const after = text.slice(lastIndex).replace(/<[^>]+>/g, '');
  if (after) parts.push(<span key={key++}>{after}</span>);

  return parts.length > 0 ? parts : <span>{text.replace(/<[^>]+>/g, '')}</span>;
};

export default parseNotificationMessage;
